module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc1"
    }
  }, [_vm._v("The Basics")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In the first part of this book, you’ll learn about the raw-edge appliqué technique I call Scrappy Bits Appliqué—it’s the perfect appliqué technique for modern quilters. You’ll find several different options for each step, so that you will be able to modify and choose the techniques that best suit your preferences and design choices. You’ll find out about these considerations and more:")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("■")]), _vm._v("How to plan or design your quilt")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("■")]), _vm._v("Color theory basics and how to choose a color palette for your quilt")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("■")]), _vm._v("The materials needed and recommended for this style of quilting")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("■")]), _vm._v("How to make the quilt, including different collage techniques and approaches as well as quiltmaking basics")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v("■")]), _vm._v("Several different methods for finishing a quilt")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("The Projects")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In the second section of the book are eight quilt projects—you can put your new appliqué and collage quilting skills to work! Included are charts that will help you make each quilt in a variety of sizes as well as patterns for each collaged design.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("For even more quilts and patterns, visit my website: "), _c('a', {
    attrs: {
      "href": "http://thebottletree.net",
      "target": "_blank"
    }
  }, [_vm._v("thebottletree.net")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-113bccba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_chapter1.vue
// module id = 72
// module chunks = 0